import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import worksheetMaker from './reducers/worksheet-maker';
import logger from 'redux-logger';

const middleware = process.env.REACT_APP_BUILD_ENV !== 'production' ? [thunk, logger] : [thunk];

const globalReducer = combineReducers({
  worksheetMaker
});
const Store = createStore(globalReducer, applyMiddleware(...middleware));

export default Store;
